/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  PaymentMethodVerificationRequest,
  PaymentMethodVerificationResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Verify a payment method
 */
export const verifyPaymentMethod = (
  paymentMethodVerificationRequest: PaymentMethodVerificationRequest,
  options?: SecondParameter<
    typeof backofficeRequest<PaymentMethodVerificationResponse>
  >,
) => {
  return backofficeRequest<PaymentMethodVerificationResponse>(
    {
      url: `/payment-method/verify`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: paymentMethodVerificationRequest,
    },
    options,
  )
}
export type VerifyPaymentMethodResult = NonNullable<
  Awaited<ReturnType<typeof verifyPaymentMethod>>
>
